(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('tagList', [TagListFn]);

    function TagListFn() {

        var directive = {
            link: link,
            restrict: 'E',
            replace: true,
            templateUrl: '/app/global/templates/rf-global-tag-list.template.html',
            scope: {
                items: '=',
                model: '=',
                deletable: '@?',
                placeholdertext: '@?',
                required: '@?',
                appendToBody: '@?',
                inputType: '@?', // type for input field (text, number...), default: text
                createItemFn: '&?', // creates a new object for the item list, has parameter 'value'
                compareItemFn: '&?', // compares a list-item with the input value, has parameters 'listItem', 'valueItem'
                displayValue: '@?', // the property of the object that is used for display
                minValue: '@?', // min value
                onChange: '=?'
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.inEditMode = false;
            // used for input-field and holds the display-value of the model or the new user input
            // use object to enable correct 2way binding
            scope.inputModel = { value: null };

            activate();

            scope.inputLostFocus = function () {
                addValueToListIfNotExists(scope.inputModel.value, true);
            };

            scope.delete = function () {
                scope.model = null;
                setInputModel();
            };

            // user selected an item from the dropdown list
            scope.listSelectionChanged = function (item) {
                scope.model = item;
                setInputModel();
                if (scope.onChange) {
                    scope.onChange(item);
                }
            };

            function activate() {
                scope.items = scope.items || [];
                // if not set by user, set to default value 'text'
                if (!scope.inputType)
                    scope.inputType = 'text';

                setInputModel();
                addValueToListIfNotExists(scope.inputModel.value, false);
            }

            // sets the input model from the given model
            function setInputModel() {
                if (scope.model === undefined || scope.model === null) {
                    scope.inputModel.value = null;
                }
                else {
                    scope.inputModel.value = scope.displayValue ? scope.model[scope.displayValue] : scope.model;
                }
            }

            // adds the given value to the item-list if it's not in there yet
            // if setModel is true, the scope.model property is overwritten with the given value
            function addValueToListIfNotExists(value, setModel) {
                if (!value)
                    return;

                var valueExists = false;
                var valueObject = value;

                // for object-lists: create the correct object with the value
                if (scope.createItemFn) {
                    valueObject = scope.createItemFn({ value: value });
                }

                var i = 0;
                var len = scope.items.length;

                for (i; i < len; i++) {
                    // for object-lists: compare the value-object with the list-item
                    if (scope.compareItemFn) {
                        valueExists = scope.compareItemFn({ listItem: scope.items[i], valueItem: valueObject });
                    }
                    else {
                        // for simple types: compare the list item with the value
                        valueExists = scope.items[i] === value;
                    }

                    if (valueExists) {
                        if (setModel) {
                            // use list-item for correct object-referencing (id,...)
                            scope.model = scope.items[i];
                        }
                        break;
                    }
                } // for

                if (!valueExists) {
                    scope.items.push(valueObject);

                    if (setModel) {
                        scope.model = valueObject;
                    } // if
                } // if
            } // addValueToListIfNotExists
        } // link
    }

})();